var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "vue-social" } },
    [
      _c(
        "div",
        { staticClass: "post__interactions", attrs: { "data-did": _vm.dId } },
        [
          _c(
            "div",
            {
              staticClass: "card-message right",
              class: { show: _vm.showMessage },
              style: { bottom: "auto", top: _vm.msgY },
            },
            [
              _c("img", {
                attrs: { src: _vm.$cdn("/img/ui/cancel.svg"), alt: "close" },
                on: { click: _vm.close },
              }),
              _vm._v(" "),
              _c("div", [_c("h5", [_vm._v(_vm._s(_vm.message.title))])]),
              _vm._v(" "),
              _c("p", { domProps: { innerHTML: _vm._s(_vm.message.content) } }),
              _vm._v(" "),
              _vm.message.showLink
                ? _c("p", [
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.like(true)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.message.linkText))]
                    ),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "post__likes",
              class: { liked: _vm.postLiked },
              on: {
                click: function ($event) {
                  return _vm.like(false)
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "21",
                    viewBox: "0 0 24 21",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M11.728 19.8376C11.29 19.5766 1 13.3538 1 6.76474C1 3.58612 3.62739 1 6.85673 1C9.02896 1 10.9907 2.18834 12 4.00725C13.0093 2.18834 14.971 1 17.1433 1C20.3726 1 23 3.58612 23 6.76474C23 13.3538 12.71 19.5755 12.272 19.8376L12 20L11.728 19.8376Z",
                      stroke: "black",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.postLikes))]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "post__comments",
              class: { commented: _vm.commented },
              on: { click: _vm.comment },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "22",
                    height: "21",
                    viewBox: "0 0 22 21",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M21 20L19.4891 14.4021C20.4468 12.339 20.6181 10.0081 19.9719 7.83187C19.3256 5.65568 17.9047 3.77825 15.9665 2.53997C14.0284 1.30168 11.7014 0.784484 9.40743 1.08212C7.11341 1.37975 5.00419 2.47254 3.46214 4.16235C1.92008 5.85216 1.04725 8.02716 1.00186 10.2931C0.956479 12.559 1.74155 14.7659 3.21475 16.5136C4.68796 18.2614 6.7518 19.4343 9.03214 19.8198C11.3125 20.2053 13.6584 19.7779 15.6446 18.615L21 20Z",
                      stroke: "black",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.commentsCount))]),
            ]
          ),
          _vm._v(" "),
          _vm.showReposts
            ? _c(
                "div",
                {
                  staticClass: "post__repost",
                  class: { reposted: _vm.hasReposted },
                  on: { click: _vm.repost },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "22",
                        height: "16",
                        viewBox: "0 0 22 16",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M1 4V6C1 9.31371 3.68629 12 7 12H11M21 12V10C21 6.68629 18.3137 4 15 4H11",
                          stroke: "black",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M14 1L11 4L14 7",
                          stroke: "black",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M9 15L12 12L9 9",
                          stroke: "black",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.reposts > 0 ? _vm.reposts : "")),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "post__share" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.shareButtons.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "21",
                      height: "21",
                      viewBox: "0 0 21 21",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M1 9V18C1 19.1046 1.89543 20 3 20H18C19.1046 20 20 19.1046 20 18V9",
                        stroke: "black",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M11 14.7748V2.4248",
                        stroke: "black",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M6.25 5.75L11 1L15.75 5.75",
                        stroke: "black",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.reposts > 0
        ? _c(
            "div",
            {
              staticClass: "post__reposts u-cursor-pointer",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.openRepostedModal.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "post__reposted" }, [
                _vm.reposts === 1
                  ? _c("span", [
                      _vm._v(
                        "Reposted in " + _vm._s(_vm.reposts) + " community"
                      ),
                    ])
                  : _c("span", [
                      _vm._v(
                        "Reposted in " + _vm._s(_vm.reposts) + " communities"
                      ),
                    ]),
                _vm._v(" "),
                _vm.repostedCommunities.length > 0
                  ? _c(
                      "div",
                      { staticClass: "post__reposted-communities" },
                      [
                        _vm._l(
                          _vm.repostedCommunities.slice(0, 3),
                          function (community, index) {
                            return _c(
                              "div",
                              {
                                key: community.community_id,
                                staticClass: "post__reposted-community",
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: _vm.$simpleStore.transformImageWithCloudfront(
                                      40,
                                      40,
                                      "img/communities/" +
                                        community.community_id +
                                        "/" +
                                        community.image,
                                      _vm.$root
                                    ),
                                    alt: community.name,
                                  },
                                }),
                              ]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _vm.reposts > 3
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "post__reposted-community post__reposted-community--more",
                              },
                              [_vm._v("+" + _vm._s(_vm.reposts - 3))]
                            )
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Menu",
        {
          attrs: {
            "show-menu": _vm.showRepostedModal,
            "close-event": _vm.repostedModalCloseEvent,
            top: true,
            "scroll-class": "menu__content--scroll",
          },
        },
        [
          _c("div", [
            _c("div", { staticClass: "menu__title" }, [
              _c("p", [
                _vm._v(
                  '"' +
                    _vm._s(_vm.postTitle) +
                    '" has been reposted to the following communities'
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "menu__items" },
              _vm._l(_vm.repostedCommunities, function (community) {
                return _c(
                  "a",
                  {
                    key: community.community_id,
                    staticClass: "items",
                    attrs: { href: "/" + community.url + "/reposts" },
                  },
                  [
                    _c("img", {
                      staticClass: "u-radius-4",
                      attrs: {
                        src: _vm.$simpleStore.transformImageWithCloudfront(
                          50,
                          50,
                          "img/communities/" +
                            community.community_id +
                            "/" +
                            community.image,
                          _vm.$root
                        ),
                        alt: community.name,
                        width: "50",
                        height: "50",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "items__details" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(community.name) +
                            "\n                            "
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              community.repost_count === 1
                                ? "1 repost"
                                : community.repost_count + " reposts"
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.showReposts
        ? _c("ugc-reposting", {
            ref: "repostPanel",
            attrs: {
              standalone: true,
              modal: true,
              "dyadey-id": _vm.dId,
              "source-community-id": _vm.$root.post
                ? _vm.$root.post.community_id
                : 0,
              "has-reposted": _vm.hasReposted,
            },
            on: {
              "repost-success": _vm.onRepostSuccess,
              "repost-removed": _vm.onRepostRemoved,
              "no-communities": _vm.onNoCommunities,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }